import Sortable from "sortablejs";
document.addEventListener("DOMContentLoaded", function () {
  const el = document.getElementById("widgets");
  if (!el) return;
  Sortable.create(el);
});
